export * from './sync-account.component';
export * from './sync-form';
export * from './sync-success';
export * from './sync-faild';